import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { HOME_PAGE } from "../Constants";

export default function showViewerOnboardingTour() {
  const driverObj = driver({
    showProgress: true,
    allowClose: true,
    steps: [
      {
        popover: {
          title: "Allow Camera Access",
          description: "Please allow camera access to scan QR code",
        },
      },
      {
        popover: {
          title: "Where is your QR code?",
          description: `Using your computer, go to <b>${process.env.REACT_APP_FE_HOST}${HOME_PAGE}</b> to continue...`,
        },
      },
      {
        element: "#qr-code-scanner",
        popover: {
          title: "Time to Scan QR code",
          description: "Please Scan QR code to connect",
          side: "bottom",
          align: "center",
          onNextClick: () => {
            const qrScanner = document.querySelector("#qr-code-scanner");
            if (!qrScanner) {
              driverObj.moveNext();
            }
          },
        },
      },
      {
        popover: {
          title: "Nice! Pin Transfered successfully",
          description:
            "You should now see your pin displayed on your computer. Now you can begin pairing",
        },
      },
    ],
  });
  setTimeout(() => {
    driverObj.drive();
  }, 1000);
}
